// @ts-nocheck

import axios from 'axios';
import localstorageKeys from 'constants/localstorageKeys';

import { getLocalStorageItem } from '../hooks/localStorageHelper';

const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'content-type': 'application/json',
  },
});

AxiosInstance.interceptors.request.use(
  (config: any) => {
    const appLang = getLocalStorageItem('lang');
    const defLang = getLocalStorageItem('i18nextLng');

    // eslint-disable-next-line no-param-reassign
    config.headers = {
      ...config.headers,
      'x-app-language': appLang || defLang,
    };

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const handleLogoutRedirectUser = () => {
  localStorage.removeItem(localstorageKeys.AUTH_TOKEN);
  localStorage.removeItem(localstorageKeys.REFRESH_TOKEN);
  localStorage.removeItem(localstorageKeys.USER_DATA);
  window.location.href = routes.HOME.pathname;
};

AxiosInstance.interceptors.request.use(async (config: any) => {
  const authToken = await getLocalStorageItem('AUTH_TOKEN');
  if (authToken) {
    // eslint-disable-next-line no-param-reassign
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${authToken}`,
      // 'x-device-token': authSession?.access_token,
    };

    return config;
  }
  return config;
});

// const isRefreshing = false;

AxiosInstance.interceptors.response.use(
  (response) => {
    return response?.data;
  },
  async (error) => {
    // const originalRequest = error.config;

    // if (error?.response?.status === 401 && !originalRequest.retryFlag) {
    //   originalRequest.retryFlag = true;

    //   if (isRefreshing) {
    //     return Promise.reject(error);
    //   }
    //   isRefreshing = true;
    //   try {
    //     const newAccessToken = await RefreshAccessToken();
    //     if (newAccessToken) {
    //       handleRefreshAuthtokens(newAccessToken);
    //       isRefreshing = false;
    //       return await AxiosInstance(originalRequest);
    //     }
    //   } catch (refreshError) {
    //     isRefreshing = false;
    //     handleLogoutRedirectUser();
    //     return Promise.reject(refreshError);
    //   }
    // }

    // if (
    //   error?.response?.status === 401 &&
    //   !(await getLocalStorageItem(localstorageKeys.AUTH_TOKEN))
    // ) {
    //   handleLogoutRedirectUser();
    // }
    if (error?.response?.status === 401) {
      handleLogoutRedirectUser();
    }
    return Promise.reject(error.response.data || error.response);
  }
);

export const useAPI = async (props: {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  data?: object;
  formData?: any;
  headers?: any;
  params?: any;
}) => {
  const { url, method = 'GET', headers, ...rest } = props;
  const result = AxiosInstance({
    url,
    method,
    headers,
    ...rest,
  });

  const { data } = await result;
  return data;
};

export default AxiosInstance;
